/** Browser name. Currently the browers other than 'FireFox' named as 'Others'. */
type BrowserType = 'Firefox' | 'Others';

export const browser: BrowserType =
  navigator.userAgent.indexOf('Firefox') !== -1 ? 'Firefox' : 'Others';
